import type { BonusAward, BonusKpi } from "./use-staff-bonuses";
import { advanceMoney } from "./use-staff-advances";
import { amountChanged, amountText, amountType } from "./staff-step21";
import { bonusText } from "./staff-bonus-model";
import "./staff-step21.css";

export function KpiAmount({kpi:k,rtl,compact=false}:{kpi:BonusKpi;rtl:boolean;compact?:boolean}){
 const t=(s:string)=>bonusText(amountText(s,rtl),rtl),type=amountType(k);
 if(type==="range")return <>{rtl?`من ${advanceMoney(k.minAmount||0)} إلى ${advanceMoney(k.maxAmount||0)} ج.م، حسب اختيارك`:`${advanceMoney(k.minAmount||0)} to ${advanceMoney(k.maxAmount||0)} EGP, you choose`}</>;
 if(type==="suggested")return <>{advanceMoney(k.amount)} {rtl?"ج.م مقترح":"EGP suggested"}</>;
 return <>{advanceMoney(k.amount)} {t(compact?"EGP":"EGP each time")}</>;
}
export function AwardAmountNote({award:a,rtl,detail=false}:{award:BonusAward;rtl:boolean;detail?:boolean}){
 const t=(s:string)=>bonusText(amountText(s,rtl),rtl),s=a.amountSettings;
 if(amountChanged(a))return <small className="awchg">↕ {t(detail?"suggested":"from")} {advanceMoney(s!.suggestedAmount!)}{detail&&<> {t("EGP")}, {t("changed by")} {a.giverName} · {t("reported to finance")}</>}</small>;
 if(!detail||!s)return null;
 return <small className="muted"> · {s.type==="range"?<>{rtl?"اختاره":"chosen by"} {a.giverName}, {rtl?"بين":"within"} {advanceMoney(s.minAmount||0)} {t("to")} {advanceMoney(s.maxAmount||0)}</>:t(s.type==="suggested"?"the suggested amount":"set by the KPI")}</small>;
}
